export default __webpack_public_path__ + "static/media/xray.11ffb6e1.txt";